module.exports = {
      id: "chat_bubble-usage",
      viewBox: "0 0 87 87",
      url: __webpack_public_path__ + "img/icons.b9c19baa.svg#chat_bubble-usage",
      toString: function () {
        return this.url;
      }
    }